export default __webpack_public_path__ + "images/954605e2634d06688a220e4661c7caf5-foot-logo.svg";